import { createContext, useContext } from "react";

// Default context value
const defaultContextValue = {
  tags: [],
  tagTypes: [],
  selectedTabType: null,
  loading: false,
  error: null,
  entityId: null,
  entityName: null,
  entityType: null,
  editMode: false,
  setEditMode: () => {},
  dispatch: () => {},
  onTabChange: () => {},
  onPageChange: () => {},
  pagination: {
    limit: 5,
    offset: 0,
    totalCount: 0,
  },
};

export const TagsHierarchyViewerContext = createContext(defaultContextValue);

export const useTagsHierarchyViewer = () => {
  return useContext(TagsHierarchyViewerContext);
};
